<template>
  <div class="section4-content">
    <img
      src="../../assets/product/section4_2.png"
      alt="img"
      class="item-view-img"
    />
  </div>
</template>
<script>
export default {
  name: "productItem2",
  data() {
    return {};
  },
};
</script>
<style scoped lang="less">
.section4-content {
  width: 1110px;
  margin: 85px auto 128px;
}
.img {
  width: 100%;
}
</style>
